(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dnvii-intro"] && !Shopify.designMode) return;
  try {
    (() => {
    const intro = document.getElementById('dnvii-intro');
    if (!intro || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    try {
      if (sessionStorage.getItem('dnvii-intro-seen')) return;
      sessionStorage.setItem('dnvii-intro-seen', '1');
    } catch (error) {}
    let closed = false;
    let timer;
    const close = () => {
      if (closed) return;
      closed = true;
      clearTimeout(timer);
      intro.classList.add('is-leaving');
      window.setTimeout(() => intro.remove(), 700);
    };
    intro.querySelector('.dnvii-intro__skip')?.addEventListener('click', close);
    intro.setAttribute('aria-hidden', 'false');
    intro.classList.add('is-visible');
    timer = window.setTimeout(close, 4200);
  })();
  } catch(e) { console.error(e); }
})();

})();
